export var RequestStatusEnum;

(function (RequestStatusEnum) {
  RequestStatusEnum["pending"] = "Pending";
  RequestStatusEnum["approved"] = "Approved";
  RequestStatusEnum["rejected"] = "Denied";
  RequestStatusEnum["solved"] = "Solved";
  RequestStatusEnum["threshold"] = "Threshold";
})(RequestStatusEnum || (RequestStatusEnum = {}));

export var RequestSolutionOriginEnum;

(function (RequestSolutionOriginEnum) {
  RequestSolutionOriginEnum["requested"] = "Requested";
  RequestSolutionOriginEnum["added"] = "Added";
})(RequestSolutionOriginEnum || (RequestSolutionOriginEnum = {}));